const callsToAction = (): void => {
  const scrollLinks = document.querySelectorAll<HTMLElement>(".cta--scroll");

  const smoothScroll = (event: MouseEvent): void => {
    event.preventDefault();

    const targetId = (event.currentTarget as HTMLElement).getAttribute("href");

    if (typeof targetId === "string") {
      const targetElement = document.querySelector<HTMLElement>(targetId);

      if (targetElement) {
        const elementRect = targetElement.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.pageYOffset;
        const middle =
          absoluteElementTop - window.innerHeight / 2 + elementRect.height / 2;

        window.scrollTo({
          top: middle,
          behavior: "smooth",
        });
      }
    }
  };

  scrollLinks.forEach((link: HTMLElement) => {
    link.addEventListener("click", smoothScroll);
  });
};

export default callsToAction;
